"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.link = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const transition_1 = require("../basic/transition");
const colors_1 = require("../basic/colors");
const spaces_1 = require("../basic/spaces");
const cta_1 = require("./cta");
exports.link = (0, basic_1.applyBase)({
    primary: {
        transition: transition_1.transition.fast,
        '&:hover': {
            color: colors_1.colors.interactionPrimary,
            textDecorationColor: colors_1.colors.defaultText,
        },
    },
    cta: Object.assign(Object.assign({}, cta_1.ctaStyles), { textAlign: 'center', paddingLeft: spaces_1.space[4], paddingRight: spaces_1.space[4], borderRadius: '6px', paddingTop: '8px', paddingBottom: '8px', border: '2px solid', borderColor: colors_1.colors.primary, ':focus:not([disabled])': {
            border: '2px solid',
            backgroundColor: colors_1.colors.interactionPrimary,
            borderColor: colors_1.colors.interactionPrimary,
            color: colors_1.baseColors.white,
        }, ':hover:not([disabled]),:focus-visible:not([disabled])': {
            backgroundColor: colors_1.colors.interactionPrimary,
            borderColor: colors_1.colors.interactionPrimary,
            color: colors_1.baseColors.white,
        } }),
    text: {
        color: colors_1.colors.primary,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    allOffers: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LINK_LARGE), { display: 'flex', alignItems: ['center', 'flex-start'], svg: {
            alignSelf: 'center',
            marginLeft: spaces_1.space[2],
            width: '16px',
            height: '16px',
        }, transition: 'none', textDecoration: 'underline', textDecorationColor: colors_1.colors.linkUnderlineColor, textUnderlineOffset: '6px', '&:hover,&:focus': {
            transform: 'scale(1)',
            color: colors_1.colors.defaultText,
            textDecorationColor: colors_1.colors.defaultText,
        } }),
    iconLink: {
        fontSize: '0px',
        letterSpacing: 'initial',
        padding: 1,
    },
    imgLink: {
        fontSize: '0px',
        letterSpacing: 'initial',
    },
    blockLink: {
        display: 'block',
        '&:hover': { color: 'initial' },
    },
    priceLink: Object.assign(Object.assign({}, cta_1.ctaStyles), { '&:hover': {
            color: colors_1.baseColors.white,
        }, width: '100%', textAlign: 'right', p: 2 }),
    breadcrumbLink: {
        color: colors_1.colors.defaultText,
        marginRight: spaces_1.space[2],
        textDecoration: 'underline',
        textDecorationColor: colors_1.colors.linkUnderlineColor,
        textUnderlineOffset: '6px',
        transition: 'none',
        '&:hover,&:focus': {
            transform: 'scale(1)',
            color: colors_1.colors.defaultText,
            textDecorationColor: colors_1.colors.defaultText,
        },
    },
});
//# sourceMappingURL=link.js.map